// Spec rev84 (2026-08-02) — indice visuel du raccourci clavier "/".
// Petit badge gris façon touche de clavier affiché à droite d'un champ
// de recherche tant que celui-ci n'est ni focus ni rempli. Signale
// l'existence du raccourci implémenté dans hooks/useSearchShortcut.js
// (rev82).
export default function SearchShortcutHint({ visible, testid }) {
  if (!visible) return null;
  return (
    <span
      aria-hidden="true"
      className="absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none select-none flex items-center justify-center font-mono"
      style={{
        minWidth: 18,
        height: 18,
        padding: "0 5px",
        fontSize: 11,
        lineHeight: 1,
        borderRadius: 5,
        background: "rgba(255,255,255,0.06)",
        border: "1px solid rgba(255,255,255,0.14)",
        color: "rgba(237,237,237,0.55)",
        boxShadow: "inset 0 -1px 0 rgba(0,0,0,0.35)",
      }}
      title="Appuyez sur / pour focus la recherche"
      data-testid={testid}
    >
      /
    </span>
  );
}
